import { type ReactNode } from "react";
import { useCurrentUser } from "@/hooks/useCurrentUser";

interface AdminGuardProps {
  children: ReactNode;
}

export function AdminGuard({ children }: AdminGuardProps) {
  const { data: currentUser, isLoading, isError } = useCurrentUser();

  if (isLoading) {
    return <div className="p-8">Checking admin access...</div>;
  }

  if (isError || !currentUser) {
    return (
      <div className="p-8 text-red-600">
        Unable to verify super admin access. Please sign in again.
      </div>
    );
  }

  if (!currentUser.is_super_admin) {
    return (
      <div className="p-8 text-red-600">
        You do not have permissions to access this page.
      </div>
    );
  }

  return <>{children}</>;
}
